export const getFileExtension = (fileName) => {
  let charIndex = fileName.lastIndexOf(".");
  return fileName.substring(charIndex + 1);
};

export const changeSubCategoryValue = (value) => {
  switch (value) {
    case "file2spec":
      return "File to Specification";
    case "file2Db":
      return "File to Database";
    case "file2File":
      return "File to File";
    case "db2Db":
      return "Database to Database";
    case "eventMonitor":
      return "Event Monitor";
    case "extractCompressed":
      return "Extract Compressed File";
    case "fileManipulation":
      return "File Manipulation";
    case "move":
      return "File Move, Copy or Delete";
    case "uiTest":
      return "UI Test";
    default:
      return value;
  }
};

export const changeSubCategoryKey = (value) => {
  switch (value) {
    case "File to Specification":
      return "file2spec";
    case "File to Database":
      return "file2Db";
    case "File to File":
      return "file2File";
    case "Database to Database":
      return "db2Db";
    case "Event Monitor":
      return "eventMonitor";
    case "Extract Compressed File":
      return "extractCompressed";
    case "File Manipulation":
      return "fileManipulation";
    case "File Move, Copy or Delete":
      return "move";
    case "UI Test":
      return "uiTest";
    default:
      break;
  }
};

export const changeCategoryValue = (value) => {
  switch (value) {
    case "compare":
      return "Compare";
    case "process":
      return "Process Automation";
    case "ui":
      return "UI Automation";
    default:
      break;
  }
};

export const changeCategoryKey = (value) => {
  switch (value) {
    case "Compare":
      return "compare";
    case "Process Automation":
      return "process";
    case "UI Automation":
      return "ui";
    default:
      break;
  }
};

export const splitSubCategory = (subCategory) => {
  console.log(subCategory);
  if (!subCategory) {
    return { subCategory1: "", subCategory2: "NA" };
  }

  const parts = subCategory.split(" to ");

  if (parts.length > 1) {
    return {
      subCategory1: parts[0].trim(),
      subCategory2: parts.slice(1).join(" to ").trim(),
    };
  } else {
    return {
      subCategory1: subCategory.trim(),
      subCategory2: "NA",
    };
  }
};
